/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectPenaltiesChangeDecisionForProjectPenaltyPost } from '../fn/project-penalties/api-project-penalties-change-decision-for-project-penalty-post';
import { ApiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Params } from '../fn/project-penalties/api-project-penalties-change-decision-for-project-penalty-post';
import { apiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain } from '../fn/project-penalties/api-project-penalties-change-decision-for-project-penalty-post-plain';
import { ApiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain$Params } from '../fn/project-penalties/api-project-penalties-change-decision-for-project-penalty-post-plain';
import { apiProjectPenaltiesCreateProjectPenaltyPost } from '../fn/project-penalties/api-project-penalties-create-project-penalty-post';
import { ApiProjectPenaltiesCreateProjectPenaltyPost$Params } from '../fn/project-penalties/api-project-penalties-create-project-penalty-post';
import { apiProjectPenaltiesCreateProjectPenaltyPost$Plain } from '../fn/project-penalties/api-project-penalties-create-project-penalty-post-plain';
import { ApiProjectPenaltiesCreateProjectPenaltyPost$Plain$Params } from '../fn/project-penalties/api-project-penalties-create-project-penalty-post-plain';
import { apiProjectPenaltiesDeleteProjectPenaltyDelete } from '../fn/project-penalties/api-project-penalties-delete-project-penalty-delete';
import { ApiProjectPenaltiesDeleteProjectPenaltyDelete$Params } from '../fn/project-penalties/api-project-penalties-delete-project-penalty-delete';
import { apiProjectPenaltiesDeleteProjectPenaltyDelete$Plain } from '../fn/project-penalties/api-project-penalties-delete-project-penalty-delete-plain';
import { ApiProjectPenaltiesDeleteProjectPenaltyDelete$Plain$Params } from '../fn/project-penalties/api-project-penalties-delete-project-penalty-delete-plain';
import { apiProjectPenaltiesGetProjectPenaltiesPost } from '../fn/project-penalties/api-project-penalties-get-project-penalties-post';
import { ApiProjectPenaltiesGetProjectPenaltiesPost$Params } from '../fn/project-penalties/api-project-penalties-get-project-penalties-post';
import { apiProjectPenaltiesGetProjectPenaltiesPost$Plain } from '../fn/project-penalties/api-project-penalties-get-project-penalties-post-plain';
import { ApiProjectPenaltiesGetProjectPenaltiesPost$Plain$Params } from '../fn/project-penalties/api-project-penalties-get-project-penalties-post-plain';
import { ChangeDecisionForProjectPenaltyCommandResult } from '../models/change-decision-for-project-penalty-command-result';
import { CreateProjectPenaltyCommandResult } from '../models/create-project-penalty-command-result';
import { DeleteProjectPenaltyCommandResult } from '../models/delete-project-penalty-command-result';
import { GetProjectPenaltiesQueryResult } from '../models/get-project-penalties-query-result';

@Injectable({ providedIn: 'root' })
export class ProjectPenaltiesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectPenaltiesGetProjectPenaltiesPost()` */
  static readonly ApiProjectPenaltiesGetProjectPenaltiesPostPath = '/api/ProjectPenalties/GetProjectPenalties';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesGetProjectPenaltiesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesGetProjectPenaltiesPost$Plain$Response(params?: ApiProjectPenaltiesGetProjectPenaltiesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPenaltiesQueryResult>> {
    return apiProjectPenaltiesGetProjectPenaltiesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesGetProjectPenaltiesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesGetProjectPenaltiesPost$Plain(params?: ApiProjectPenaltiesGetProjectPenaltiesPost$Plain$Params, context?: HttpContext): Observable<GetProjectPenaltiesQueryResult> {
    return this.apiProjectPenaltiesGetProjectPenaltiesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectPenaltiesQueryResult>): GetProjectPenaltiesQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesGetProjectPenaltiesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesGetProjectPenaltiesPost$Response(params?: ApiProjectPenaltiesGetProjectPenaltiesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectPenaltiesQueryResult>> {
    return apiProjectPenaltiesGetProjectPenaltiesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesGetProjectPenaltiesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesGetProjectPenaltiesPost(params?: ApiProjectPenaltiesGetProjectPenaltiesPost$Params, context?: HttpContext): Observable<GetProjectPenaltiesQueryResult> {
    return this.apiProjectPenaltiesGetProjectPenaltiesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectPenaltiesQueryResult>): GetProjectPenaltiesQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectPenaltiesCreateProjectPenaltyPost()` */
  static readonly ApiProjectPenaltiesCreateProjectPenaltyPostPath = '/api/ProjectPenalties/CreateProjectPenalty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesCreateProjectPenaltyPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectPenaltiesCreateProjectPenaltyPost$Plain$Response(params?: ApiProjectPenaltiesCreateProjectPenaltyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectPenaltyCommandResult>> {
    return apiProjectPenaltiesCreateProjectPenaltyPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesCreateProjectPenaltyPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectPenaltiesCreateProjectPenaltyPost$Plain(params?: ApiProjectPenaltiesCreateProjectPenaltyPost$Plain$Params, context?: HttpContext): Observable<CreateProjectPenaltyCommandResult> {
    return this.apiProjectPenaltiesCreateProjectPenaltyPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectPenaltyCommandResult>): CreateProjectPenaltyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesCreateProjectPenaltyPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectPenaltiesCreateProjectPenaltyPost$Response(params?: ApiProjectPenaltiesCreateProjectPenaltyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectPenaltyCommandResult>> {
    return apiProjectPenaltiesCreateProjectPenaltyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesCreateProjectPenaltyPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectPenaltiesCreateProjectPenaltyPost(params?: ApiProjectPenaltiesCreateProjectPenaltyPost$Params, context?: HttpContext): Observable<CreateProjectPenaltyCommandResult> {
    return this.apiProjectPenaltiesCreateProjectPenaltyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectPenaltyCommandResult>): CreateProjectPenaltyCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectPenaltiesChangeDecisionForProjectPenaltyPost()` */
  static readonly ApiProjectPenaltiesChangeDecisionForProjectPenaltyPostPath = '/api/ProjectPenalties/ChangeDecisionForProjectPenalty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain$Response(params?: ApiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeDecisionForProjectPenaltyCommandResult>> {
    return apiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain(params?: ApiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain$Params, context?: HttpContext): Observable<ChangeDecisionForProjectPenaltyCommandResult> {
    return this.apiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChangeDecisionForProjectPenaltyCommandResult>): ChangeDecisionForProjectPenaltyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesChangeDecisionForProjectPenaltyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Response(params?: ApiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeDecisionForProjectPenaltyCommandResult>> {
    return apiProjectPenaltiesChangeDecisionForProjectPenaltyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesChangeDecisionForProjectPenaltyPost(params?: ApiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Params, context?: HttpContext): Observable<ChangeDecisionForProjectPenaltyCommandResult> {
    return this.apiProjectPenaltiesChangeDecisionForProjectPenaltyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChangeDecisionForProjectPenaltyCommandResult>): ChangeDecisionForProjectPenaltyCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectPenaltiesDeleteProjectPenaltyDelete()` */
  static readonly ApiProjectPenaltiesDeleteProjectPenaltyDeletePath = '/api/ProjectPenalties/DeleteProjectPenalty';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesDeleteProjectPenaltyDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesDeleteProjectPenaltyDelete$Plain$Response(params?: ApiProjectPenaltiesDeleteProjectPenaltyDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectPenaltyCommandResult>> {
    return apiProjectPenaltiesDeleteProjectPenaltyDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesDeleteProjectPenaltyDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesDeleteProjectPenaltyDelete$Plain(params?: ApiProjectPenaltiesDeleteProjectPenaltyDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectPenaltyCommandResult> {
    return this.apiProjectPenaltiesDeleteProjectPenaltyDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectPenaltyCommandResult>): DeleteProjectPenaltyCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectPenaltiesDeleteProjectPenaltyDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesDeleteProjectPenaltyDelete$Response(params?: ApiProjectPenaltiesDeleteProjectPenaltyDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectPenaltyCommandResult>> {
    return apiProjectPenaltiesDeleteProjectPenaltyDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectPenaltiesDeleteProjectPenaltyDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectPenaltiesDeleteProjectPenaltyDelete(params?: ApiProjectPenaltiesDeleteProjectPenaltyDelete$Params, context?: HttpContext): Observable<DeleteProjectPenaltyCommandResult> {
    return this.apiProjectPenaltiesDeleteProjectPenaltyDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectPenaltyCommandResult>): DeleteProjectPenaltyCommandResult => r.body)
    );
  }

}
